// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icons/multi_session_black.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    Tile view
*/
.users .row .assignment.col-md-3 {
  padding: 0.5rem;
}

.users .row .col-md-3 .content {
  cursor: pointer;
  height: 100%;
  position: relative;
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.users .row .col-md-3 .content img {
  height: 100%;
  width: 100%;
}

.users .row .col-md-3 .title {
  padding-top: 0.25rem;
}

.users .row .col-md-3 .title h4 {
  font-size: 16px;
  font-weight: bold;
  height: 6rem;
  /* yet another bootstrap override */
  /* Bootstrap is more like a block of cheese at this point */
  margin-top: 0;
}

.users .row .col-md-3 .title .more {
  border-left: 1px solid #fff;
  color: #fff;
  cursor: pointer;
  height: 59px;
  margin: 0px;
  padding: 20px 0px 0px 0px;
  text-align: center;
  vertical-align: middle;
}

/*
 * This is absolute garbage and causes extra work styling every page. never, ever, ever tie your css to bootstrap classes.
 * Use bootstrap to do the layout. if you have to adjust margins/padding to bootstrap, just make new classes and put the
 * margins and padding on those.
.users .row .row {
    margin: 7px 0px;
}
*/

/* Assignment status */
.status {
  color: black;
  font-weight: bold;
  font-size: 12px;
  font-style: italic;
}

.score {
  color: black;
  font-weight: bold;
  font-size: 14px;
  font-style: italic;
}

.new,
.notRegistered {
  color: #003399;
}

.confirmed,
.inProgress {
  color: #339933;
}

.waitlist {
  color: #f70;
}

.overdue {
  color: red;
}

.dueSoon,
.duesoon {
  color: #ffd000;
}

.unsuccessDiv {
  padding-top: 35px;
  padding-bottom: 30px;
}

.btn.relaunchBtn {
  text-transform: none;
  font-weight: normal;
  padding: 6px 38px 6px 38px;
  text-shadow: initial;
  margin-top: 14px;
  border: none;
}
.btn.relaunchBtn:hover,
.btn.relaunchBtn:active,
.btn.relaunchBtn:focus {
  text-transform: none;
  font-weight: normal;
  padding: 6px 38px 6px 38px;
  text-shadow: 0px 0px 0px #fff;
  margin-top: 14px;
  border: none;
}
.unsuccessAssignName {
  margin: 0 0 10px;
}
.unsuccessAttempts {
  padding-top: 5px;
  padding-bottom: 1px;
  font-size: 14px;
}
.unsuccessScore {
  margin: 0 0 3px;
  font-size: 14px;
  color: red;
}
.unsuccessHeader {
  padding-left: 25px;
  padding-top: 30px;
  font-size: 35px;
}
.unsuccessTitle {
  font-size: 16px;
}

/**
* Assignment tile
*/

.tile {
  padding: 5px;
}

/* On the tile view, make the tiles in the left column
 * have a left padding of 0 and the tiles in the right
 * column have a right padding of 0. that way the tiles
 * are flush with the margins of the page */
#listPage div.tile.leftColumn {
  padding-left: 0;
}
#listPage div.tile.rightColumn {
  padding-right: 0;
}

.assignmentPadding {
  background-color: #e5e5e5;
  min-height: 375px;
  padding: 1rem;
}

.careerpath-assignmentPadding {
  background-color: #e5e5e5;
  min-height: 475px;
  padding: 1rem;
}

.tile img {
  margin-bottom: 15px;
  width: 100%;
}

.tile h4 {
  color: black;
  font-size: 16px;
  font-weight: bold;
}

/* Do not move these in a different order
Otherwise the won't fire when the page shrinks correctly */
@media (min-width: 768px) {
  .tile h4 {
    height: 6.5rem;
  }
}

@media (min-width: 992px) {
  .tile h4 {
    height: 5rem;
  }
}
@media (min-width: 1300px) {
  .tile h4 {
    height: 3.5rem;
  }
}

.dueDate {
  color: black;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 8px;
}

/* Make ng-show do visibility hidden on the dueDate */
.dueDate.hidden {
  /* Override display: none !important in vendor.min.css */
  display: block !important;
  visibility: hidden;
}

#courseList .actionHolder .spinner4 {
  float: left;
  margin-right: 15px;
}

.more {
  color: black;
  text-decoration: underline;
  font-size: 14px;
  padding-bottom: 1rem;
}

#courseList .more {
  color: black;
  float: left;
  font-size: 14px;
  text-decoration: underline;
}

.courseGroupMore {
  color: black;
  float: left;
  font-size: 14px;
  text-decoration: underline;
}

a.assignmentFilter {
  margin-left: 2rem;
}

.alert-tile {
  color: #000;
  margin: 1rem 0rem;
  background-color: #f2dede;
  padding: 1px;
  border: 1px solid transparent;
  border-radius: 4px;
  margin-bottom: 15px;
  margin-top: -10px;
  border-color: #ebccd1 !important;
}

.alert-list {
  color: #000;
  margin: 1rem 0rem;
  background-color: #f2dede;
  padding: 3px;
  border: 1px solid transparent;
  border-radius: 4px;
  border-color: #ebccd1 !important;
  margin: 0rem 0rem;
  text-align: center;
}

/*
* Generic rule for the launch button which appears outside of the slide down.
*/
#courseList .actionHolder a.btn,
#courseList .actionHolder button {
  float: left;
  margin-right: 45px;
}

.courseGroupIcon {
  width: 3rem;
  height: 2rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  display: inline-block;
  background-repeat: no-repeat;
}

#courseList .courseGroupIcon {
  margin-left: 2rem;
  margin-top: 1rem;
}
.statusContainer {
  display: inline-flex;
  height: 2px;
}

#courseList .courseListTitle {
  display: flex;
}

/* View Resources start */

.resource {
  color: black;
  text-decoration: underline;
  font-size: 14px;
  margin-top: 10px;
  float: left;
  padding-bottom: 1rem;
  padding-left: 15px;
}

.resourceForCourseGroup {
  margin-top: 0px !important;
}

#viewResources {
  margin-bottom: 5px;
  width: 100%;
  margin-top: 3px;
  padding: 0px 5px;
  float: left;
  display: block;
  position: relative;
}

#courseList #resourcesContainer {
  padding-top: 40px;
}

.resourceHeaders {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
}
.resourceName {
  width: 80%;
  padding-left: 20px;
}
.resourceFileFormat {
  width: 10%;
}
.resourceSize {
  width: 10%;
}

.resourceBody {
  border-bottom: 1px solid #e5e5e5;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 14px !important;
}

.resourceNameDetails {
  width: 80%;
  padding-left: 20px;
}

.resourceFileFormatDetails {
  width: 10%;
}

.resourceSizeDetails {
  width: 10%;
}

.launchBtnResources {
  margin-right: 7px !important;
}

#courseList #viewResources .body {
  background-color: #f2f2f2;
  overflow: hidden;
  padding: 5px;
  padding-left: 10px;
  padding-bottom: 25px;
}

.disabled-btn {
  color: black;
}
/* View Resources end */
.inactivetab {
  text-align: right;
  width: 50%;
  padding-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/tiles.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mCAAmC;EACnC,2DAA2D;EAC3D,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;CAOC;;AAED,sBAAsB;AACtB;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;;CAEC;;AAED;EACE,YAAY;AACd;;AAEA;;;2CAG2C;AAC3C;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;0DAC0D;AAC1D;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD;EACE,wDAAwD;EACxD,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mDAAoE;EACpE,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;;AAEzB;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;AACA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB","sourcesContent":["/*\n    Tile view\n*/\n.users .row .assignment.col-md-3 {\n  padding: 0.5rem;\n}\n\n.users .row .col-md-3 .content {\n  cursor: pointer;\n  height: 100%;\n  position: relative;\n  width: 100%;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.users .row .col-md-3 .content img {\n  height: 100%;\n  width: 100%;\n}\n\n.users .row .col-md-3 .title {\n  padding-top: 0.25rem;\n}\n\n.users .row .col-md-3 .title h4 {\n  font-size: 16px;\n  font-weight: bold;\n  height: 6rem;\n  /* yet another bootstrap override */\n  /* Bootstrap is more like a block of cheese at this point */\n  margin-top: 0;\n}\n\n.users .row .col-md-3 .title .more {\n  border-left: 1px solid #fff;\n  color: #fff;\n  cursor: pointer;\n  height: 59px;\n  margin: 0px;\n  padding: 20px 0px 0px 0px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n/*\n * This is absolute garbage and causes extra work styling every page. never, ever, ever tie your css to bootstrap classes.\n * Use bootstrap to do the layout. if you have to adjust margins/padding to bootstrap, just make new classes and put the\n * margins and padding on those.\n.users .row .row {\n    margin: 7px 0px;\n}\n*/\n\n/* Assignment status */\n.status {\n  color: black;\n  font-weight: bold;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.score {\n  color: black;\n  font-weight: bold;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.new,\n.notRegistered {\n  color: #003399;\n}\n\n.confirmed,\n.inProgress {\n  color: #339933;\n}\n\n.waitlist {\n  color: #f70;\n}\n\n.overdue {\n  color: red;\n}\n\n.dueSoon,\n.duesoon {\n  color: #ffd000;\n}\n\n.unsuccessDiv {\n  padding-top: 35px;\n  padding-bottom: 30px;\n}\n\n.btn.relaunchBtn {\n  text-transform: none;\n  font-weight: normal;\n  padding: 6px 38px 6px 38px;\n  text-shadow: initial;\n  margin-top: 14px;\n  border: none;\n}\n.btn.relaunchBtn:hover,\n.btn.relaunchBtn:active,\n.btn.relaunchBtn:focus {\n  text-transform: none;\n  font-weight: normal;\n  padding: 6px 38px 6px 38px;\n  text-shadow: 0px 0px 0px #fff;\n  margin-top: 14px;\n  border: none;\n}\n.unsuccessAssignName {\n  margin: 0 0 10px;\n}\n.unsuccessAttempts {\n  padding-top: 5px;\n  padding-bottom: 1px;\n  font-size: 14px;\n}\n.unsuccessScore {\n  margin: 0 0 3px;\n  font-size: 14px;\n  color: red;\n}\n.unsuccessHeader {\n  padding-left: 25px;\n  padding-top: 30px;\n  font-size: 35px;\n}\n.unsuccessTitle {\n  font-size: 16px;\n}\n\n/**\n* Assignment tile\n*/\n\n.tile {\n  padding: 5px;\n}\n\n/* On the tile view, make the tiles in the left column\n * have a left padding of 0 and the tiles in the right\n * column have a right padding of 0. that way the tiles\n * are flush with the margins of the page */\n#listPage div.tile.leftColumn {\n  padding-left: 0;\n}\n#listPage div.tile.rightColumn {\n  padding-right: 0;\n}\n\n.assignmentPadding {\n  background-color: #e5e5e5;\n  min-height: 375px;\n  padding: 1rem;\n}\n\n.careerpath-assignmentPadding {\n  background-color: #e5e5e5;\n  min-height: 475px;\n  padding: 1rem;\n}\n\n.tile img {\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n.tile h4 {\n  color: black;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* Do not move these in a different order\nOtherwise the won't fire when the page shrinks correctly */\n@media (min-width: 768px) {\n  .tile h4 {\n    height: 6.5rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .tile h4 {\n    height: 5rem;\n  }\n}\n@media (min-width: 1300px) {\n  .tile h4 {\n    height: 3.5rem;\n  }\n}\n\n.dueDate {\n  color: black;\n  font-weight: bold;\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n\n/* Make ng-show do visibility hidden on the dueDate */\n.dueDate.hidden {\n  /* Override display: none !important in vendor.min.css */\n  display: block !important;\n  visibility: hidden;\n}\n\n#courseList .actionHolder .spinner4 {\n  float: left;\n  margin-right: 15px;\n}\n\n.more {\n  color: black;\n  text-decoration: underline;\n  font-size: 14px;\n  padding-bottom: 1rem;\n}\n\n#courseList .more {\n  color: black;\n  float: left;\n  font-size: 14px;\n  text-decoration: underline;\n}\n\n.courseGroupMore {\n  color: black;\n  float: left;\n  font-size: 14px;\n  text-decoration: underline;\n}\n\na.assignmentFilter {\n  margin-left: 2rem;\n}\n\n.alert-tile {\n  color: #000;\n  margin: 1rem 0rem;\n  background-color: #f2dede;\n  padding: 1px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  margin-top: -10px;\n  border-color: #ebccd1 !important;\n}\n\n.alert-list {\n  color: #000;\n  margin: 1rem 0rem;\n  background-color: #f2dede;\n  padding: 3px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  border-color: #ebccd1 !important;\n  margin: 0rem 0rem;\n  text-align: center;\n}\n\n/*\n* Generic rule for the launch button which appears outside of the slide down.\n*/\n#courseList .actionHolder a.btn,\n#courseList .actionHolder button {\n  float: left;\n  margin-right: 45px;\n}\n\n.courseGroupIcon {\n  width: 3rem;\n  height: 2rem;\n  background: url('../../assets/images/icons/multi_session_black.svg');\n  background-size: contain;\n  display: inline-block;\n  background-repeat: no-repeat;\n}\n\n#courseList .courseGroupIcon {\n  margin-left: 2rem;\n  margin-top: 1rem;\n}\n.statusContainer {\n  display: inline-flex;\n  height: 2px;\n}\n\n#courseList .courseListTitle {\n  display: flex;\n}\n\n/* View Resources start */\n\n.resource {\n  color: black;\n  text-decoration: underline;\n  font-size: 14px;\n  margin-top: 10px;\n  float: left;\n  padding-bottom: 1rem;\n  padding-left: 15px;\n}\n\n.resourceForCourseGroup {\n  margin-top: 0px !important;\n}\n\n#viewResources {\n  margin-bottom: 5px;\n  width: 100%;\n  margin-top: 3px;\n  padding: 0px 5px;\n  float: left;\n  display: block;\n  position: relative;\n}\n\n#courseList #resourcesContainer {\n  padding-top: 40px;\n}\n\n.resourceHeaders {\n  border-bottom: 1px solid #e5e5e5;\n  padding-bottom: 5px;\n  font-weight: bold;\n  font-size: 14px;\n}\n.resourceName {\n  width: 80%;\n  padding-left: 20px;\n}\n.resourceFileFormat {\n  width: 10%;\n}\n.resourceSize {\n  width: 10%;\n}\n\n.resourceBody {\n  border-bottom: 1px solid #e5e5e5;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-size: 14px !important;\n}\n\n.resourceNameDetails {\n  width: 80%;\n  padding-left: 20px;\n}\n\n.resourceFileFormatDetails {\n  width: 10%;\n}\n\n.resourceSizeDetails {\n  width: 10%;\n}\n\n.launchBtnResources {\n  margin-right: 7px !important;\n}\n\n#courseList #viewResources .body {\n  background-color: #f2f2f2;\n  overflow: hidden;\n  padding: 5px;\n  padding-left: 10px;\n  padding-bottom: 25px;\n}\n\n.disabled-btn {\n  color: black;\n}\n/* View Resources end */\n.inactivetab {\n  text-align: right;\n  width: 50%;\n  padding-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
